export const SET_STACK_PACKS_INDEX_FILTER = "@p-stack-packs-index/SET_FILTER";
